/**
 * @generated SignedSource<<79656d7886f59d0bebec54c88116d5b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cplId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenuePeriod",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueMin",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivePerc",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorCommProgramLineCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateCpLineTPayload",
        "kind": "LinkedField",
        "name": "createCpLineT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpLineT",
            "kind": "LinkedField",
            "name": "cpLineT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VendorCommProgramLineCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateCpLineTPayload",
        "kind": "LinkedField",
        "name": "createCpLineT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpLineT",
            "kind": "LinkedField",
            "name": "cpLineT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a55d2825c5105dc9d0bdaadf2f6abdc3",
    "id": null,
    "metadata": {},
    "name": "VendorCommProgramLineCreateMutation",
    "operationKind": "mutation",
    "text": "mutation VendorCommProgramLineCreateMutation(\n  $input: CreateCpLineTInput!\n) {\n  createCpLineT(input: $input) {\n    cpLineT {\n      cplId\n      revenuePeriod\n      revenueMin\n      incentivePerc\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "2c01b997bf574a062f6d06c97a75f199";

module.exports = node;
